module.exports = __webpack_public_path__ + "static/media/latif-blessing-go-metro.f38097ea.png";